import script from "./ListBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ListBlock.vue?vue&type=script&setup=true&lang=js"

import "./ListBlock.vue?vue&type=style&index=0&id=2036b340&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2036b340"]])

export default __exports__